import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory as createHistory } from 'history'

export const history = createHistory()

export const routerMiddlewareWithHistory = routerMiddleware(history)
